import { LayaGL } from "../../../layagl/LayaGL";
import { StatElement } from "../../../layagl/StatisticsContext";
import { GLObject } from "./WebGLEngine/GLObject";
export class WebGLInternalRT extends GLObject {
    get gpuMemory() {
        return this._gpuMemory;
    }
    set gpuMemory(value) {
        this._changeTexMemory(value);
        this._gpuMemory = value;
    }
    _changeTexMemory(value) {
        LayaGL.statAgent.recordMemoryData(StatElement.M_GPUMemory, -this._gpuMemory + value);
        LayaGL.statAgent.recordMemoryData(StatElement.M_RenderTexture, -this._gpuMemory + value);
        LayaGL.statAgent.recordMemoryData(StatElement.M_AllTexture, -this._gpuMemory + value);
    }
    constructor(engine, colorFormat, depthStencilFormat, isCube, generateMipmap, samples) {
        super(engine);
        this._gpuMemory = 0;
        this.colorFormat = colorFormat;
        this.depthStencilFormat = depthStencilFormat;
        this._isCube = isCube;
        this._generateMipmap = generateMipmap;
        this._samples = samples;
        this._textures = [];
        this._depthTexture = null;
        this._framebuffer = this._gl.createFramebuffer();
        if (samples > 1) {
            this._msaaFramebuffer = this._gl.createFramebuffer();
        }
        LayaGL.statAgent.recordCountData(StatElement.C_RenderTexture, 1);
    }
    _getSource() {
        return this._textures[0].resource;
    }
    dispose() {
        this._textures.forEach(tex => {
            tex && tex.dispose();
        });
        this._textures = null;
        this._depthTexture && this._depthTexture.dispose();
        this._depthTexture = null;
        this._framebuffer && this._gl.deleteFramebuffer(this._framebuffer);
        this._framebuffer = null;
        this._depthbuffer && this._gl.deleteRenderbuffer(this._depthbuffer);
        this._depthbuffer = null;
        this._msaaFramebuffer && this._gl.deleteFramebuffer(this._msaaFramebuffer);
        this._msaaFramebuffer = null;
        this._msaaRenderbuffer && this._gl.deleteRenderbuffer(this._msaaRenderbuffer);
        this._msaaRenderbuffer = null;
        this._changeTexMemory(0);
        this._gpuMemory = 0;
        LayaGL.statAgent.recordCountData(StatElement.C_RenderTexture, -1);
    }
}
